// 인생 사건의 대응 이벤트(선택지 3개). 발생 여부와 시기는 lifeEvents.js 가 정하고, 여기에는 무엇을 할지만 둔다.
// act 선택지를 고르면 인생 상태가 바뀐다(결혼·출산·주택·입양·이혼·재혼).
// 돈이 드는 일은 능력치가 아니라 순자산에서 빠진다: money 필드(lib/scenes.js 의 applySceneMoney)와 경제 모델(lib/economy.js)이 처리한다.
// hint 는 선택지 아래에 보이는 결과 한 줄이다.
const choice = (label, kind, trait, targetField, effects, failureEffects, risk, successText, failureText, extra = {}) => ({
  label, kind, trait, targetField, delta: effects[targetField] ?? 0, risk, effects, failureEffects, successText, failureText, ...extra });

export const LIFE_EVENT_CONTENT = {
  illness: {
    field: '관성', title: '몸이 안 좋아 병원비가 든다',
    description: '몸 상태가 나빠져 병원 진료가 길어진다. 올해 병원비가 늘 수 있다.',
    choices: [
      choice('바로 치료를 받는다', 'act', '안정', '비겁', {}, {}, 0.1,
        '치료를 시작해 병원비를 냈다. 몸 상태가 더 나빠지지는 않았다.', '치료가 길어져 병원비가 더 들었다.',
        { timeCost: 1, hint: '병원비 {만원:500} · 건강 유지', money: { always: { net: { abs: -500 }, medical: 'paid' }, fail: { net: { abs: -300 } } } }),
      choice('일정 때문에 치료를 미룬다', 'decline', '원칙', '관성', { 관성: -1 }, { 관성: -1 }, 0,
        '치료를 미뤘다. 몸이 무거워 일에 집중하기 어려웠다.', '치료를 미뤘다. 몸이 무거워 일에 집중하기 어려웠다.',
        { bearsCost: true, hint: '올해는 0원 · 내년 병원비 {만원:750} · 직업↓', money: { always: { medical: 'deferred' } } }),
      choice('가족과 상의해 치료 일정을 나눈다', 'alternative', '배려', '비겁', { 비겁: 1 }, { 비겁: 0 }, 0.1,
        '가족과 병원비와 일정을 나눠 맡았다.', '일정을 나누지 못해 혼자 병원을 오갔다.',
        { timeCost: 1, hint: '병원비 {만원:250} · 관계↑', money: { always: { net: { abs: -250 }, medical: 'paid' }, fail: { net: { abs: -250 } } } }),
    ],
  },
  jobChange: {
    field: '관성', title: '하던 일을 바꿀 계기가 생긴다',
    description: '회사 사정이나 계약 문제로 지금 일을 이어가기 어려워졌다. 같은 분야에서 옮길지, 다른 분야로 갈지 정해야 한다.',
    choices: [
      choice('같은 분야에서 새 자리를 찾는다', 'act', '안정', '관성', { 관성: 2 }, { 관성: -1 }, 0.2,
        '같은 분야에서 새 자리를 구했다.', '지원한 자리에서 연락이 오지 않아 시간이 길어졌다.', { timeCost: 1, hint: '직업↑ · 실패하면 구직이 길어짐' }),
      choice('당분간 쉬며 방향을 정한다', 'decline', '신중', '인성', { 인성: 0 }, { 인성: 0 }, 0,
        '일을 쉬며 다음 방향을 생각했다.', '일을 쉬며 다음 방향을 생각했다.', { hint: '변화 없음' }),
      choice('다른 분야로 옮길 준비를 한다', 'alternative', '열정', '인성', { 인성: 2 }, { 인성: 1 }, 0.15,
        '새 분야에 필요한 내용을 배우며 준비했다.', '준비가 길어졌지만 배운 내용은 남았다.', { timeCost: 1, hint: '학업↑ · 준비 기간 필요' }),
    ],
  },
  house: {
    field: '재성', title: '집을 살 기회가 온다',
    description: '살 수 있는 집이 나왔다. 구입하면 목돈이 나가고 대출이 생길 수 있다.',
    choices: [
      choice('집을 구입한다', 'act', '안정', '재성', { 재성: 2 }, { 재성: 0 }, 0.15,
        '집을 구입해 계약을 마쳤다.', '구입 절차에서 조건이 맞지 않아 구입하지 못했다.', { timeCost: 1, hint: '집 가치와 대출이 함께 생김 · 순자산은 구입 자금만큼 현금이 줄어듦' }),
      choice('구입을 미룬다', 'decline', '신중', '재성', { 재성: 0 }, { 재성: 0 }, 0,
        '이번에는 구입하지 않았다.', '이번에는 구입하지 않았다.', { hint: '변화 없음' }),
      choice('임차를 이어가며 자금을 모은다', 'alternative', '원칙', '재성', { 재성: 1 }, { 재성: 0 }, 0.1,
        '임차를 이어가며 저축 계획을 세웠다.', '저축 계획을 세웠지만 계획대로 모으지 못했다.', { timeCost: 1, hint: '재물↑ · 저축 계획' }),
    ],
  },
  marriage: {
    field: '비겁', title: '결혼을 할까?',
    description: '함께할 사람과 결혼 이야기가 나온다. 결혼하면 가족이 늘고 생활 방식이 바뀐다.',
    choices: [
      choice('결혼한다', 'act', '배려', '비겁', { 비겁: 3 }, { 비겁: -1 }, 0.1,
        '결혼식을 올리고 함께 살기 시작했다.', '준비 과정에서 의견이 갈려 일정이 밀렸다.', { timeCost: 1, hint: '관계↑ · 결혼 비용 {만원:6298} − 축의금 {만원:1350} = 순 {만원:4948}(신혼집 제외) · 가구가 2명이 되어 생활비가 늘고 배우자 소득이 더해짐', money: { success: { net: { abs: -4948 } } } }),
      choice('결혼을 미룬다', 'decline', '신중', '비겁', { 비겁: 0 }, { 비겁: 0 }, 0,
        '결혼 시기를 더 미루기로 했다.', '결혼 시기를 더 미루기로 했다.', { hint: '변화 없음' }),
      choice('함께 살며 지켜본다', 'alternative', '열정', '비겁', { 비겁: 1 }, { 비겁: 0 }, 0.1,
        '혼인 신고 없이 함께 살며 생활을 맞췄다.', '생활 방식이 맞지 않아 따로 지냈다.', { timeCost: 1, hint: '관계 조금↑ · 비용 적음' }),
    ],
  },
  birth: {
    field: '비겁', title: '아이를 가질까?',
    description: '아이를 가질 시기가 왔다. 아이를 맞이하면 가구원이 늘어 생활비가 오르고, 돌볼 시간이 필요하다.',
    choices: [
      choice('양육 계획을 세우고 맞이한다', 'act', '배려', '비겁', { 비겁: 2 }, { 비겁: 0 }, 0.1,
        '아이를 맞이하고 양육 계획을 세웠다.', '준비가 부족해 처음 몇 달이 힘들었다.', { timeCost: 1, hint: '관계↑ · 가구원이 늘어 생활비가 오름' }),
      choice('시기를 조절한다', 'decline', '신중', '비겁', { 비겁: 0 }, { 비겁: 0 }, 0,
        '이번에는 아이를 갖지 않기로 했다.', '이번에는 아이를 갖지 않기로 했다.', { hint: '변화 없음' }),
      choice('가족에게 도움을 청해 함께 키운다', 'alternative', '안정', '비겁', { 비겁: 1 }, { 비겁: 0 }, 0.1,
        '가족의 도움을 받아 양육을 나눴다.', '도움을 받을 일정이 맞지 않았다.', { timeCost: 1, hint: '관계 조금↑' }),
    ],
  },
  pet: {
    field: '식상', title: '반려동물을 들일 기회가 온다',
    description: '지인이 키우던 동물을 맡길 곳을 찾는다. 들이면 돌봄 시간과 비용이 든다.',
    choices: [
      choice('반려동물을 들인다', 'act', '배려', '식상', { 식상: 2 }, { 식상: 0 }, 0.1,
        '반려동물을 들이고 돌봄 시간을 정했다.', '돌봄 시간이 맞지 않아 지인에게 다시 맡겼다.', { timeCost: 1, hint: '활동↑ · 매년 약 {만원:146} 지출' }),
      choice('들이지 않는다', 'decline', '신중', '식상', { 식상: 0 }, { 식상: 0 }, 0,
        '이번에는 들이지 않았다.', '이번에는 들이지 않았다.', { hint: '변화 없음' }),
      choice('주말에만 돌봐 준다', 'alternative', '열정', '식상', { 식상: 1 }, { 식상: 0 }, 0.05,
        '주말에만 동물을 돌봤다.', '주말 일정이 겹쳐 돌보지 못했다.', { timeCost: 1, hint: '활동 조금↑' }),
    ],
  },
  divorce: {
    field: '비겁', title: '결혼 생활을 이어갈지 정한다',
    description: '오래 쌓인 갈등으로 결혼 생활을 이어갈지 따져야 하는 때가 왔다.',
    choices: [
      choice('이혼한다', 'act', '원칙', '비겁', { 비겁: -2 }, { 비겁: -3 }, 0.1,
        '이혼 절차를 마쳤다. 생활을 새로 꾸려야 한다.', '절차가 길어져 한 해를 넘겼다.', { timeCost: 1, bearsCost: true, hint: '관계↓ · 이혼 비용 약 {만원:600} · 재산이 절반으로 나뉨', money: { success: { net: { abs: -600 } } } }),
      choice('그대로 이어간다', 'decline', '안정', '비겁', { 비겁: 0 }, { 비겁: 0 }, 0,
        '결혼 생활을 이어가기로 했다.', '결혼 생활을 이어가기로 했다.', { hint: '변화 없음' }),
      choice('상담을 받고 다시 맞춰 본다', 'alternative', '배려', '비겁', { 비겁: 1 }, { 비겁: 0 }, 0.2,
        '상담을 받으며 서로의 생활을 다시 맞췄다.', '상담을 받았지만 갈등이 이어졌다.', { timeCost: 1, hint: '관계 조금↑' }),
    ],
  },
  remarriage: {
    field: '비겁', title: '다시 함께할 사람이 생긴다',
    description: '이혼 뒤 새로 만난 사람과 함께 살 이야기가 나온다.',
    choices: [
      choice('다시 결혼한다', 'act', '배려', '비겁', { 비겁: 2 }, { 비겁: -1 }, 0.15,
        '다시 결혼해 생활을 함께하기 시작했다.', '준비 과정에서 의견이 갈려 일정이 밀렸다.', { timeCost: 1, hint: '관계↑ · 재혼 비용 약 {만원:3150} − 축의금 {만원:400} = 순 {만원:2750} · 가구가 늘어남', money: { success: { net: { abs: -2750 } } } }),
      choice('혼자 지내기로 한다', 'decline', '신중', '비겁', { 비겁: 0 }, { 비겁: 0 }, 0,
        '당분간 혼자 지내기로 했다.', '당분간 혼자 지내기로 했다.', { hint: '변화 없음' }),
      choice('가까운 사이로 지켜본다', 'alternative', '안정', '비겁', { 비겁: 1 }, { 비겁: 0 }, 0.1,
        '혼인 없이 가까운 사이로 지냈다.', '일정이 맞지 않아 자주 만나지 못했다.', { timeCost: 1, hint: '관계 조금↑' }),
    ],
  },
};

// 자동 기록(선택 없음)과 진행 기록에 남는 문장. 상태가 실제로 바뀐 사건만 쓴다.
export const LIFE_RECORD_TEXT = {
  illness: '병원비가 든 병을 앓았다', jobChange: '일을 바꿀 계기가 생겼다', house: '집을 구입했다', marriage: '결혼했다',
  birth: '아이가 태어났다', pet: '반려동물을 들였다', petDeath: '반려동물이 세상을 떠났다', divorce: '이혼했다', remarriage: '다시 결혼했다',
};
